import { Button, Col, Popconfirm, Row, Table, Typography } from 'antd';
import locale from 'antd/es/locale/pt_BR';

import ContaForm from '../SolicitacoesDeAtivacao/Gerenciar/Tabs/AlinhamentoDeContasEFontes/components/ContaForm';
import { useContasACadastrar } from './useContasACadastrar';

const { Text } = Typography;

const ContasACadastrar = () => {
    const {
        clickBotaoCadastrarConta,
        clickBotaoIgnorarConta,
        hasSelectedCadastrar,
        loadingIgnorar,
        loadingTable,
        onclickTable,
        rowSelection,
        contasACadastrar,
        columns,
        refContagemDoFiltro,
        propsState,
        handleResetRowSelection,
        contaSelecionada,
        handleCloseContaForm,
        handleContaCreated,
    } = useContasACadastrar();

    return (
        <>
            <div
                style={{
                    position: 'fixed',
                    zIndex: 2,
                    paddingTop: 24,
                    paddingBottom: 10,
                    paddingLeft: 24,
                    paddingRight: 10,
                    margin: -24
                }}
            >
                <Row>
                    <Col>
                        <Button type="primary"
                            style={{ marginRight: 5, marginBottom: 5 }}
                            className="btn_success_vlhbegoawrgbvr" onClick={clickBotaoCadastrarConta} disabled={!hasSelectedCadastrar || loadingIgnorar}
                        >
                            Cadastrar
                        </Button>
                    </Col>
                    <Col>
                        <Popconfirm
                            title="Deseja realmente ignorar esta conta?"
                            onConfirm={clickBotaoIgnorarConta}
                            okText="Sim"
                            cancelText="Não"
                            disabled={!hasSelectedCadastrar || loadingIgnorar}
                        >
                            <Button
                                danger
                                type="primary"
                                style={{ marginRight: 5, marginBottom: 5 }}
                                disabled={!hasSelectedCadastrar}
                                loading={loadingIgnorar}
                            >
                                Ignorar
                            </Button>
                        </Popconfirm>
                    </Col>
                </Row>

            </div>

            <Table
                style={{
                    marginTop: 50
                }}
                className='marginTopTables'
                rowClassName={(record, index) => "ativoList"}
                rowKey={(record) => record.id}
                loading={loadingTable}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => { onclickTable(record, rowIndex) },
                    };
                }}
                rowSelection={rowSelection}
                columns={columns} dataSource={contasACadastrar}
                scroll={{ x: 1000 }}
                onChange={
                    (pagination, filters, sorter, extra) => {
                        handleResetRowSelection();
                        refContagemDoFiltro.current = extra.currentDataSource
                    }
                }
                title={(registros) => {

                    return (
                        <div
                            style={{
                                backgroundColor: propsState.theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                                padding: 10,
                                margin: -8,
                                marginBottom: 0.5
                            }}
                        >
                            <Text>
                                {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                    contasACadastrar.length :
                                    refContagemDoFiltro.current.length} num total de ${contasACadastrar.length} `}
                            </Text>
                        </div>
                    )
                }}
                footer={(registros) => {
                    return (
                        <div
                            style={{
                                textAlign: 'end'
                            }}
                        >
                            <Text>
                                {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                    contasACadastrar.length :
                                    refContagemDoFiltro.current.length} num total de ${contasACadastrar.length} `}
                            </Text>
                        </div>
                    )
                }}
                size="small"
                pagination={{
                    locale: { items_per_page: '' },
                    showSizeChanger: true,
                    defaultPageSize: 100,
                    position: ['topRight', 'bottomRight'],
                    pageSizeOptions: ['10', '20', '50', '100']
                }}
                locale={locale.Table}
            />

            <ContaForm
                visible={!!contaSelecionada}
                conta={null}
                contaACadastrar={contaSelecionada}
                onClose={handleCloseContaForm}
                onContaCreated={handleContaCreated}
            />
        </>
    );
}

export default ContasACadastrar;
